import { PriceSummaryRow } from '@ps-design-system/components/PriceSummary';
import { Text } from '@ps-design-system/components/Text';
import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipTrigger
} from '@ps-design-system/components/Tooltip';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';

export const ProcessingLineItem = ({
  processingFee,
  currency,
  leanMoreLink,
  tooltipAlign = 'center'
}) => {
  const [showTooltip, setShowTooltip] = React.useState(false);

  return (
    <PriceSummaryRow
      testId="processing-line-item"
      name={(
        <Tooltip
          rootProps={{
            delayDuration: 0,
            open: showTooltip,
            onOpenChange: setShowTooltip
          }}
        >
          <TooltipTrigger
            onClick={(e) => {
              e.preventDefault();
              setShowTooltip((prev) => !prev);
            }}
          >
            <Text style={{ textDecoration: 'underline' }}>
              <FormattedMessage
                id="price_summary.processing_fee"
                defaultMessage="Processing"
              />
            </Text>
          </TooltipTrigger>
          <TooltipContent style={{ maxWidth: '248px' }} align={tooltipAlign}>
            <Text typeface="body-1-long">
              <FormattedMessage
                id="price_summary.processing_fee_tooltip"
                defaultMessage="This covers costs that allow Peerspace to complete your transaction and provide support for your booking. {learnMore}"
                values={{
                  learnMore: (
                    <a
                      href={leanMoreLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: 'underline' }}
                    >
                      <FormattedMessage
                        id="price_summary.learn_more"
                        defaultMessage="Learn more"
                      />
                    </a>
                  )
                }}
              />
            </Text>
            <TooltipArrow className="tw-fill-base-white" />
          </TooltipContent>
        </Tooltip>
      )}
      value={(
        <FormattedNumber
          value={processingFee || 0}
          style="currency"
          currency={currency}
        />
      )}
    />
  );
};

ProcessingLineItem.displayName = 'ProcessingLineItem';
ProcessingLineItem.propTypes = {
  processingFee: PropTypes.number,
  currency: PropTypes.string,
  leanMoreLink: PropTypes.string,
  tooltipAlign: PropTypes.string
};
